const tagsView = {
  state: {
    visitedViews: [
    ]
  },
  getters: {
    visitedViews: state => state.tagsView.visitedViews
  },
  mutations: {
    addTags(state, payload) {
      let flag = null
      const tags = JSON.parse(localStorage.getItem('tags')) //  获取刷新页面以后保存的tags
      localStorage.removeItem('tags') //  获取之后删除session,避免关闭tags后的错误
      if (tags) {
        state.visitedViews = tags
      }
      flag = state.visitedViews.some(
        item => item.path === payload.route.path
      )// 打开标签后，判断数组中是否已经存在该路由
      if (!flag) {
        state.visitedViews.push(
          Object.assign(
            {},
            {
              path: payload.route.path,
              name: payload.route.name,
              title: payload.route.meta.name,
              query: payload.route.query,
              tagsName: payload.route.query.name ? payload.route.query.name : ''// 动态渲染的路由就给他添加一个tagsName    比如在列表页打开详情
            }
          )
        )
      } // 数组中路由存在不push ,单击左侧路由变化,点击标签路由变化均触发
    }
  },
  actions: {
    closeTags(state, payload) {
      for (const [key, item] of state.state.visitedViews.entries()) {
        if (item.path === payload.path) {
          return {
            delEl: state.state.visitedViews.splice(key, 1),
            index: key
          }
        }
      }
    },
    closeALLTags(state) {
      state.state.visitedViews = [
      ]
    }
  }
}

export default tagsView
